export const AFROAM_COLLECTION = {
  id: "afroam",
  name: "AfroAm Heritage Collection",
  subtitle: "Inaugural Drop · 2026",
  description:
    "Designed in partnership with athletes and crafted with the colors of two cultures. Limited drops, premium fabric, championship intent.",
  accent: "amber",
  products: [
    {
      id: "afroam-athletic-set",
      name: "AfroAm Athletic Set",
      tagline: "On the court. Off the court.",
      price: 89,
      image: "/store/athletic-set.jpg",
      description:
        "Premium cotton-blend tee with African-pattern ribbed trim, performance leggings featuring side-stripe AFROAM heritage panel, paired with the signature embroidered cap.",
      includes: [
        "AFROAM logo tee with African ribbon trim",
        "Performance leggings with AFROAM heritage side-panel",
        "Embroidered AFROAM cap",
      ],
      sizes: ["XS", "S", "M", "L", "XL"],
      colors: ["Black / Heritage"],
    },
    {
      id: "afroam-dress-tee",
      name: "AfroAm Heritage Tee + Skirt",
      tagline: "Off the court. Still on the move.",
      price: 79,
      image: "/store/dress-set.jpg",
      description:
        "Heritage Tee styled with a satin maxi skirt — a versatile look that carries the AfroAm crest from team practice to evening events. Paired with AfroAm-stamped sandals.",
      includes: [
        "AFROAM Heritage Tee (African-pattern ribbed trim)",
        "Satin high-slit maxi skirt",
        "AFROAM crest sandals",
      ],
      sizes: ["XS", "S", "M", "L", "XL"],
      colors: ["Black / Heritage"],
    },
    {
      id: "afroam-warmup-suit",
      name: "AfroAm Women's Heritage Warm-Up Suit",
      tagline: "Black Heritage. Full Court.",
      price: 145,
      image: "/store/warmup-suit.jpg",
      description:
        "The official AfroAm Women's Warm-Up Suit — a full zip-up tracksuit in matte black accented with red, green, and gold pan-African stripes. Features the AfroAm Basketball Association crest, 'Black Heritage Month' chest copy, and Kente-pattern panels down the sleeves and side stripes. Built for the team plane, the pre-game tunnel, and the moment after the buzzer.",
      includes: [
        "AFROAM Zip-Up Track Jacket (heritage stripe collar & hem)",
        "AFROAM Tapered Track Pants (Kente side panel)",
        "Optional matching AfroAm Heritage Sneaker",
      ],
      sizes: ["XS", "S", "M", "L", "XL", "XXL"],
      colors: ["Black / Pan-African Heritage"],
    },
  ],
};

export const COLLECTIONS = [AFROAM_COLLECTION];

// Legacy export for backward compatibility
export const PRODUCTS = AFROAM_COLLECTION.products;
